import { render, staticRenderFns } from "./AiAssistance.vue?vue&type=template&id=625f9d68&scoped=true&"
import script from "./AiAssistance.vue?vue&type=script&lang=js&"
export * from "./AiAssistance.vue?vue&type=script&lang=js&"
import style0 from "./AiAssistance.vue?vue&type=style&index=0&id=625f9d68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625f9d68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VContainer,VIcon,VMain,VTextarea})
